import React from 'react';
import { Box, Typography, Button, Paper, Avatar, Fade } from '@mui/material';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import { useNavigate } from 'react-router-dom';

export const AccessDenied: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Fade in={true} timeout={500}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                // 🚀 ТВОЙ ФИРМЕННЫЙ ФОН ИЗ MessageList
                bgcolor: '#5c7bb0',
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org fill='%23ffffff' fill-opacity='0.15'%3E%3Ccircle cx='40' cy='40' r='2'/%3E%3C/g%3E%3C/svg%3E")`,
                p: 3
            }}>
                <Paper elevation={10} sx={{
                    maxWidth: 400,
                    p: 5,
                    borderRadius: '32px', // Твой стиль Orion
                    textAlign: 'center',
                    bgcolor: 'rgba(255, 255, 255, 0.98)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
                }}>
                    <Avatar sx={{
                        width: 80,
                        height: 80,
                        bgcolor: 'rgba(92, 123, 176, 0.1)',
                        color: '#5c7bb0',
                        margin: '0 auto 24px',
                    }}>
                        <LockPersonIcon sx={{ fontSize: 40 }} />
                    </Avatar>

                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#2c3e50', mb: 1.5 }}>
                        Доступ ограничен
                    </Typography>

                    <Typography variant="body1" sx={{ color: '#546e7a', mb: 4, lineHeight: 1.6, px: 2 }}>
                        Эта беседа защищена протоколом Orion. <br/>
                        Возможно, вас удалили из группы или ссылка неверна.
                    </Typography>

                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => navigate('/dashboard')}
                        sx={{
                            borderRadius: '16px',
                            py: 1.8,
                            bgcolor: '#5c7bb0',
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 700,
                            boxShadow: '0 8px 20px rgba(92, 123, 176, 0.4)',
                            '&:hover': { bgcolor: '#4a6691', boxShadow: 'none' }
                        }}
                    >
                        Вернуться к списку
                    </Button>
                </Paper>
            </Box>
        </Fade>
    );
};
